import {
  queryAccountCertifications as publicQueryAccountCertifications,
  typedQueryAccountCertifications as publicTypedQueryAccountCertifications,
  listAccountCertifications as publicListAccountCertifications,
} from './academy-certifications-v1-account-certification-account-certifications.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  AccountCertificationQuery,
  AccountCertificationsQueryBuilder,
  typedQueryAccountCertifications as universalTypedQueryAccountCertifications,
} from './academy-certifications-v1-account-certification-account-certifications.universal.js';

function customQueryAccountCertifications(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryAccountCertifications(httpClient)(),
    typedQueryFunction: (query: AccountCertificationQuery) =>
      publicTypedQueryAccountCertifications(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): AccountCertificationsQueryBuilder;
  function overloadedQuery(
    query: AccountCertificationQuery
  ): ReturnType<typeof universalTypedQueryAccountCertifications>;
  function overloadedQuery(query?: AccountCertificationQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const listAccountCertifications: MaybeContext<
  BuildRESTFunction<typeof publicListAccountCertifications> &
    typeof publicListAccountCertifications
> = /*#__PURE__*/ createRESTModule(publicListAccountCertifications);
export const queryAccountCertifications: MaybeContext<
  BuildRESTFunction<typeof customQueryAccountCertifications> &
    typeof customQueryAccountCertifications
> = /*#__PURE__*/ createRESTModule(customQueryAccountCertifications);

export {
  CertificationType,
  SortOrder,
  WebhookIdentityType,
} from './academy-certifications-v1-account-certification-account-certifications.universal.js';
export {
  AccountCertification,
  CertifyAccountRequest,
  CertifyAccountResponse,
  DecertifyAccountRequest,
  DecertifyAccountResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  QueryAccountCertificationsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryAccountCertificationsResponse,
  CursorPagingMetadata,
  Cursors,
  ListAccountCertificationsRequest,
  ListAccountCertificationsResponse,
  Certification,
  TeamMemberRemovedEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  AccountCertificationsQueryResult,
  AccountCertificationsQueryBuilder,
  AccountCertificationQuerySpec,
} from './academy-certifications-v1-account-certification-account-certifications.universal.js';
export { utils } from './academy-certifications-v1-account-certification-account-certifications.universal.js';
export {
  CertificationTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  AccountCertificationQuery,
} from './academy-certifications-v1-account-certification-account-certifications.universal.js';
